<template>
  <div>
    <v-form class="mx-5" ref="form_info" v-model="valid">
      <v-row v-if="is_component_show_event && !loading">
        <v-col cols='12' class="mx-2 py-7" align="right">
          <v-btn v-if="['in_negociation'].includes(event.status)" small dense text type="submit" class="mx-2 btn-primary" align="center" @click="setToEvent()">
            <v-icon left>mdi-star</v-icon>
            Converter em Evento
          </v-btn>
          <v-btn v-if="['waiting', 'open'].includes(event.status) && !is_block_calendar" small dense text type="submit" class="mx-2 btn-secondary" align="center" @click="backToNegotiation()">
            <v-icon left>mdi-undo</v-icon>
            Voltar a negociar
          </v-btn>
          <v-btn small dense text type="submit" class="mx-2 btn-error" align="center" @click="$emit('cancelEditing')">
            <v-icon left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-btn small dense text type="submit" class="mx-2 btn-success" align="center" @click="submitEvent('updateEvent')">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <template v-if='!loading && event'>
        <div class="pt-5">
          <v-row class="pa-0">
            <v-col cols='12' lg='6' md="6" class="py-2">
              <v-text-field dense outlined v-model="event.name" label="Nome do evento" :rules="required"></v-text-field>
            </v-col>
            <v-col cols='12' lg='6' md="6" class="py-2">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="status_items_to_show" label="Status" v-model="event.status"></v-select>
            </v-col>
          </v-row>
          <v-row class="pa-0 mt-n5" v-if="!is_block_calendar">
            <v-col cols='12' lg='6' md="6" class="py-2" v-if="!is_block_calendar">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="size_items" label="Público" v-model="event_detail_attributes.size"></v-select>
            </v-col>
            <v-col cols='12' lg='6' md="6" class="py-2" v-if="!is_block_calendar">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="event_profile_items" label="Perfil do evento" v-model="event.kind"></v-select>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col align="center" cols='12' lg='6' class="py-0">
            <calendar-date-picker :required_date="true" @datePicked="handleDataPickStartAt" is_component_show_event :date="event.start_at" :max="is_component_show_event ? event.end_at : ''" :label="'Data '+(is_block_calendar? 'de início' : 'do evento') " />
          </v-col>
          <v-col cols='12' lg='6' class="pt-2 d-flex justify-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  tile
                  :color="event.color || 'primary'"
                  elevation="4"
                  class="white--text" dense
                >
                <v-icon color="white">
                  mdi-brush
                </v-icon>
                Cor {{is_block_calendar? 'do bloqueio' : is_negotiation? 'da negociação' : 'do evento'}}
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <calendar-color-picker  is_color_existe :color_prop="event.color" @color='handleColor'></calendar-color-picker>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col v-if="false" align="center" cols='12' lg='4' class="py-0">
            <calendar-time-picker @timePicked="handleTimePickStartAt" is_component_show_event :time="event.start_time"  label="Horário de início"/>
          </v-col>
          <v-col v-if="false" align="center" cols='12' lg='4' class="py-0">
            <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="category_items" label="Categoria" v-model="event.category"></v-select>
          </v-col>
        </v-row>
        <v-row >
          <v-col v-if="is_block_calendar" align="center" cols='12' lg='6' class="py-0">
            <calendar-date-picker :min="is_component_show_event ? event.start_at : ''" @datePicked="handleDataPickEndAt" is_component_show_event :date="event.end_at"  label="Data de Término" />
          </v-col>
          <v-col v-if="false" align="center" cols='12' lg='4' class="py-0">
            <calendar-time-picker @timePicked="handleTimePickEndAt" is_component_show_event :time="event.end_time"  label="Horário de término" />
          </v-col>
          <v-col v-if="false" cols='12' lg='6' class="pt-2 d-flex justify-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  tile
                  :color="event.color || 'primary'"
                  elevation="4"
                  class="white--text" dense
                >
                <v-icon color="white">
                  mdi-brush
                </v-icon>
                Cor do evento
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <calendar-color-picker  is_color_existe :color_prop="event.color" @color='handleColor'></calendar-color-picker>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="pa-0" v-if="!is_block_calendar">
          <v-col cols='12' md='2' class="py-0">
            <v-text-field v-mask="zipMask" dense outlined v-model="event_detail_attributes.zip" label="CEP" @input="fetchZip"></v-text-field>
          </v-col>
          <v-col cols='12' md='4' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.street" label="Rua"></v-text-field>
          </v-col>
          <v-col cols='12' md='2' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.address_number" label="Nº"></v-text-field>
          </v-col>
          <v-col cols='12' md='4' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.district" label="Bairro"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pa-0" v-if="!is_block_calendar">
          <v-col cols='12' md='5' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.city" label="Cidade"></v-text-field>
          </v-col>
          <v-col cols='12' md='4' class="py-0">
            <v-select dense outlined :items="state_items" label="Estado" v-model="event_detail_attributes.state"></v-select>
          </v-col>
          <v-col cols='12' md='3' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.country" label="País"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pa-0" v-if="!is_block_calendar">
          <v-col cols='12' sm='12' class="py-0">
            <v-text-field dense outlined v-model="event_detail_attributes.place" label="Local"></v-text-field>
          </v-col>
        </v-row>
        <v-divider v-if="!is_block_calendar" class="mt-5"></v-divider>
        <div class="mt-3 mb-3" v-if="event_contact_attributes && !is_block_calendar">
          <span class="title-financial">Dados do representante 👨‍💼</span>
          <v-row class="pa-0 mt-10" v-if="!is_block_calendar">
            <v-col cols='12' sm='6' class="py-2 mt-n8">
              <v-text-field dense outlined v-model="event_contact_attributes.responsible_name" label="Responsável"></v-text-field>
            </v-col>
            <v-col cols='12' sm='6' class="py-2 mt-n8">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="responsible_kinds" label="Conexão" v-model="event_contact_attributes.responsible_kind"></v-select>
            </v-col>
            <v-col cols='12' sm='6' class="py-2 mt-n8">
              <v-text-field dense outlined v-model="event_contact_attributes.responsible_phone" v-mask="phoneMask" label="Telefone"></v-text-field>
            </v-col>
            <v-col cols='12' sm='6' class="py-2 mt-n8">
              <v-text-field dense outlined v-model="event_contact_attributes.responsible_email" label="Email"></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-divider v-if="!is_block_calendar"></v-divider>

        <form-additional-details v-if="!loading && !is_block_calendar" class="mx-n4" is_component_show_event :event_additional_details="has_additional_details ? event.json_attributes.additional_details : {}" @adittionalEventUpdated="setEventAdditionalDetails"></form-additional-details>
      </template>
      <card-loading-transparent v-if="loading"></card-loading-transparent>
      <v-btn v-if="is_component_create_event" color="primary" class="mb-4 mr-10" @click="submitEvent('createEvent')">Salvar</v-btn>
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import {CurrencyDirective} from 'vue-currency-input';
import cep from 'cep-promise'

  export default {
    name: 'EditEventInfos',
    mixins: [ validations ],
    directives: {
      currency: CurrencyDirective,
    },
    props: {
      is_component_show_event: {
        type: Boolean,
        default: ()=> {}
      },
      is_component_create_event: {
        type: Boolean,
        default: ()=> {}
      },
      event_to_edit: {
        type: Object,
        default: ()=> {}
      },
      event_detail_attributes_to_edit: {
        type: Object,
        default: ()=> {}
      },
      event_contact_attributes_to_edit: {
        type: Object,
        default: ()=> {}
      },
    },
    components: {
      CalendarColorPicker: () => import ('../../calendar/CalendarColorPicker.vue'),
      CalendarDatePicker: () => import ('../../calendar/CalendarDatePicker.vue'),
      CalendarTimePicker: () => import ('../../calendar/CalendarTimePicker.vue'),
      FormAdditionalDetails: () => import ('../FormAdditionalDetails.vue'),
    },
    data() {
      return {
        phoneMask: '(##) # ####-####',
        event_profile_items: [
          {
            text: 'Social',
            value: 'social'
          },
          {
            text: 'Corporativo',
            value: 'corporative'
          },
          {
            text: 'Cultural',
            value: 'cultural'
          },
          {
            text: 'Eletrônico',
            value: 'eletronic'
          },
          {
            text: 'Festival',
            value: 'festival'
          },
          {
            text: 'Congresso/Feira',
            value: 'congress'
          },
          {
            text: 'Bar/Restaurante',
            value: 'restaurant'
          },
          {
            text: 'Outros',
            value: 'other'
          },
        ],
        size_items: [
          { value: 'smallest', text: '0 - 100 Pessoas' },
          { value: 'smaller', text: '100 - 400 Pessoas' },
          { value: 'small', text: '400 - 700 Pessoas' },
          { value: 'medium', text: '700 - 1400  Pessoas' },
          { value: 'big', text: '1400 - 4000  Pessoas' },
          { value: 'bigger', text: '4000 - 10000 Pessoas' },
          { value: 'biggest', text: '10000 - 40000 Pessoas' },
          { value: 'xbiggest', text: '40000+ Pessoas' },
        ],
        status_items_negociation: [
          {
            text: 'Negociando',
            value: 'in_negociation'
          },
          {
            text: 'Cancelada',
            value: 'canceled_negociation'
          },
          {
            text: 'Arquivada',
            value: 'filed'
          },
        ],
        status_items_event: [
          {
            text: 'Aguardando',
            value: 'waiting'
          },
          {
            text: 'Confirmado',
            value: 'open'
          },
          {
            text: 'Cancelado',
            value: 'cancelled'
          },
          {
            text: 'Executado',
            value: 'executed'
          },
        ],
        category_items: [
          {
            text: 'Evento',
            value: 'event'
          },
          {
            text: 'Bloqueio de agenda',
            value: 'block_calendar'
          }
        ],
        responsible_kinds: [
          { value: 'producer', text: 'Produtor' }, 
          { value: 'owner', text: 'Proprietário' }, 
          { value: 'collaborator', text: 'Colaborador' }
        ],
        currency:{
          currency: null,
          locale: 'en-EN',
          autoDecimalMode: true,
          decimalLength: 2,
          distractionFree:false,
        },
        zipMask: '##.###-###',
        loading: false,
        valid: false,
        event: {
          name: '',
          status: '',
          category: '',
          start_at: '',
          end_at: '',
          start_time: '',
          end_time: '',
          color: '',
          kind: '',
        },
        event_detail_attributes: {
          size: '',
          zip: '', 
          address: '',
          description: '',
          place: '',
          city: '',
          district: '',
          state: '',
          address_number: '',
          country: '',
          street: '',
        },
        event_contact_attributes: {
          responsible_name: '',
          responsible_phone: '',
          responsible_email: '',
          responsible_kind: ''
        },
        event_additional_details: {},
        state_items: [],
      }
    },
    mounted() {
      this.setData()
    },
    methods: {
      setEventAdditionalDetails(nv){
        this.event_additional_details = {...nv}
      },
      setToEvent(){
        this.event.status = 'waiting'
        this.submitEvent('updateEvent')
      },
      backToNegotiation(){
        this.event.status = 'in_negociation'
        this.submitEvent('updateEvent')
      },
      submitEvent(create_or_update){
        let event_with_additional_details = {
          ...this.event,
          additional_details: this.event_additional_details
        }
        const { zip ,street, district, city, state, address_number } = this.event_detail_attributes
        this.event_detail_attributes.address = `CEP: ${zip || ''}, ${street || 'Rua: '}, Nº: ${address_number || ''}, ${district || 'Bairro: '}, ${city || 'Cidade: '}, ${state || 'Estado: '}`
        this.$emit(create_or_update, event_with_additional_details, this.event_detail_attributes, this.event_contact_attributes)
      },
      async setData(){
        this.loading = true
        await this.getStateItems()
        this.event = this.event_to_edit
        this.event_contact_attributes = this.event_contact_attributes_to_edit
        this.event_detail_attributes = {
          ...this.event_detail_attributes_to_edit
        }
        setTimeout(()=>{
          this.loading = false
        },600)
      },
      async getStateItems(){
        let url = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
        await fetch(url)
        .then(response => response.json())
        .then(data => {        
          data.sort((a,b) => a.nome.localeCompare(b.nome));
          data.map((state)=>{
            this.state_items.push(state.sigla)
          })
        });
      },
      verifyPickerTime(){
        this.$dayjs(`${this.event.end_at} ${this.event.end_time}`).isAfter(`${this.event.start_at} ${this.event.start_time}`) == true ? 
        this.is_event_end_after_start = true : this.date_invalid_dialog = true
      },
      handleColor(v){
        this.event.color = v
      },
      handleDataPickStartAt(v){
        this.event.start_at = v
        this.is_event_end_after_start = false
        if(this.event.end_at && this.event.start_time && this.event.end_time){
          this.verifyPickerTime()
        }
      },
      handleDataPickEndAt(v){
        this.event.end_at = v
        this.is_event_end_after_start = false
        if(this.event.start_at && this.event.start_time && this.event.end_time){
          this.verifyPickerTime()
        }
      },
      handleTimePickStartAt(v){
        this.event.start_time = v
        this.is_event_end_after_start = false
        if(this.event.end_at && this.event.start_at && this.event.end_time){
          this.verifyPickerTime()
        }
      },
      handleTimePickEndAt(v){
        this.event.end_time = v
        this.is_event_end_after_start = false
        if(this.event.end_at && this.event.start_at && this.event.start_time){
          this.verifyPickerTime()
        }
      },
      validateForm(){
        return this.$refs.form_info.validate()
      },
      fetchZip(zip) {
        if(!this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g,'')))) {
          this.loading_zip = true
          cep(zip.replace(/[.-]/g,'')).then(endereco => {
            const { street, neighborhood, city, state } = endereco
            this.event_detail_attributes.street = street
            this.event_detail_attributes.district = neighborhood
            this.event_detail_attributes.city = city
            this.event_detail_attributes.state = state
          }).finally(()=>{
            this.loading_zip = false
          })
        }
      },
    },
    computed: {
      has_additional_details(){
        if(this.event.json_attributes != undefined){
          return this.event.json_attributes.additional_details != undefined
        }else{
          return false
        }
      },
      status_items_to_show(){
        let which_status_items = 'event'
        this.status_items_negociation.map((s)=>{
          if(s.value == this.event.status){
            which_status_items = 'negociation'
          }
        })
        return which_status_items == 'negociation' ? this.status_items_negociation : this.status_items_event
      },
      address_with_number(){
        return this.event_detail_attributes.address_number ? this.event_detail_attributes.address+', Nº: '+this.event_detail_attributes.address_number : this.event_detail_attributes.address
      },
      is_block_calendar(){
        return this.event && this.event.category == 'block_calendar'
      },
      is_negotiation(){
        return this.event && this.event.category == 'event' && ['in_negociation', 'canceled_negociation', 'filed'].includes(this.event.status)

      },
    },
  }
</script>

<style lang="scss" scoped>

</style>